const accountCenterUrl = process.env.NEXT_PUBLIC_ACCOUNT_CENTER_URL;

export const NavbarMobileCreateAccountButton = () => (
  <button
    type="button"
    className="navbar-mobile-create-account-button"
    onClick={() => window.location.assign(`${accountCenterUrl}/register`)}
  >
    Create Account
  </button>
);
